var exports = {
  "xq": "legacyDockedHeader__uPww67",
  "Kp": "dockedHeader__U4oSmI",
  "$s": "headerActions__KW3udJ",
  "rf": "body__2uOH1H",
};

module.exports = exports;
